module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 const errorType=typeof type !=='undefined' ? type : '' ; ;
__p += '\r\n    ';
 const errorClass=typeof className !=='undefined' ? className : '' ; ;
__p += '\r\n        ';
 const errorIcon=typeof icon !=='undefined' ? icon : '' ; ;
__p += '\r\n\r\n            <div class="livechat_error_template  ' +
((__t = ( errorType )) == null ? '' : __t) +
' ' +
((__t = ( errorClass )) == null ? '' : __t) +
'" tabindex="0">\r\n                ';
 if (!errorIcon || errorIcon==='info' ) { ;
__p += '\r\n                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\r\n                        <path fill-rule="evenodd" clip-rule="evenodd"\r\n                            d="M19.5999 10.0004C19.5999 15.3023 15.3019 19.6004 9.99992 19.6004C4.69798 19.6004 0.399902 15.3023 0.399902 10.0004C0.399902 4.69846 4.69798 0.400391 9.99992 0.400391C15.3019 0.400391 19.5999 4.69846 19.5999 10.0004ZM11.1999 5.20039C11.1999 5.86313 10.6627 6.40039 9.99992 6.40039C9.33717 6.40039 8.79992 5.86313 8.79992 5.20039C8.79992 4.53765 9.33717 4.00039 9.99992 4.00039C10.6627 4.00039 11.1999 4.53765 11.1999 5.20039ZM8.79992 8.80039C8.13717 8.80039 7.59991 9.33765 7.59991 10.0004C7.59991 10.6631 8.13717 11.2004 8.79992 11.2004V14.8004C8.79992 15.4631 9.33717 16.0004 9.99992 16.0004H11.1999C11.8627 16.0004 12.3999 15.4631 12.3999 14.8004C12.3999 14.1376 11.8627 13.6004 11.1999 13.6004V10.0004C11.1999 9.33765 10.6627 8.80039 9.99992 8.80039H8.79992Z"\r\n                            fill="#475569" />\r\n                    </svg>\r\n                    ';
 } ;
__p += '\r\n                        <span>\r\n                            ' +
((__t = ( error )) == null ? '' : __t) +
'\r\n                        </span>\r\n            </div>';

}
return __p
}